import {ChangeTabEvent} from '../opac.directive';
import {Component, Output, EventEmitter} from 'ng-metadata/core';

//your imports go here
import {OpacService, StatusMsg} from '../opac.service';
import {RequestService} from '../request/request.service';
import {OPAC_TAB} from '../opac.directive';
import {DateUtils} from '../../../../../nddUtils/dateUtils.service';
import {FormBuilderEnums} from '../../../../../infra/formBuilder/formBuilder.service';
import {ConfigurationUtil} from '../../../../../nddUtils/configurationUtil.service';

const filter = require('lodash/filter');
const forEach = require('lodash/forEach');
const cloneDeep = require('lodash/cloneDeep');

@Component({
    selector: 'prm-copyright',
    templateUrl: 'components/search/fullView/getit/opac/copyright/copyright.html',
})


export class PrmCopyright {

    @Output() private changeTabEvent: EventEmitter<ChangeTabEvent> = new EventEmitter();
    private disable;
    constructor(private opacService: OpacService,
        private requestService: RequestService,
        private configurationUtil: ConfigurationUtil) {
        this.disable = false;
    }

    get formData() {
        return this.requestService.formData;
    }

    set formData(formData) {
        this.requestService.formData = formData;
    }

    isDisabled() {
        return this.disable;
    }

    getSubmitMessage() {
        if (this.disable) {
            return "Request in process";
        }
        else {
            return "I agree with the terms";
        }
    }

    public cancel() {
        this.changeTabEvent.emit(null); //null = Go to last tab
    }

    public commit() {
        this.disable = true;
        let service = this.requestService.service;
        let postData = cloneDeep(this.formData);

        if (!postData.group_id) { //set it as ILS API ID
            postData.group_id = this.requestService.ilsApiId;
        }

        if (postData.item_id) { //special case - request by item level
            /* update API to item level */
            service['link-to-service'] = service['link-to-service'] + '/item/' + postData.item_id;
        }
        let itemId = postData.item_id || postData.itemId;
        this.manipulatePostData(postData);
        let mmsId = itemId ? undefined : postData.group_id;

        postData.copyright = 'Y';
        
        this.opacService.makeIlsCall(service, postData, 'POST')
            .then((res) => {
                this.disable = false;
                this.opacService.responseStatus = new StatusMsg(res.status === 'ok', res['reply-text']);
                let eventData = {
                    dest: OPAC_TAB.RESPONSE,
                    itemId: itemId,
                    mmsId: mmsId
                };
                this.changeTabEvent.emit(eventData);

            });
    }

    private manipulatePostData(postData) {
        forEach(postData, (value, key) => {
            let field = this.getFieldByName(this.requestService.form, key);
            if (field) {
                if (field.fieldType === FormBuilderEnums.FIELD_TYPE.INTERNAL) {
                    delete postData[key];
                    return;
                }
                if (field.uiType === FormBuilderEnums.UI_TYPE.DATE) {
                    let dateUtils = new DateUtils();
                    postData[key] = dateUtils.convertDateTypeToIlsDateString(postData[key]);
                }
            }
        });
    }

    private getFieldByName(form, name) {
        let matchedFields = filter(form, (el) => { return el.name === name; });
        return matchedFields[0];
    }

    private getServiceType() {
        let service = this.requestService.service;
        if (service) {
            return service.type;
        }
        return undefined;
    }

    public getTitleLabel() {
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            let serviceType = this.getServiceType();
            if (serviceType === 'AlmaResourceSharing') {
                return 'almaResourceSharing.copyright.title';
            } else {
                return 'almaDigitization.copyright.title';
            }
        }
        return 'illrequest.copyright.title';
    }

    public getMessageLabel() {
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            let serviceType = this.getServiceType();
            if (serviceType === 'AlmaResourceSharing') {
                return 'almaResourceSharing.copyright.message';
            } else {
                return 'almaDigitization.copyright.message';
            }
        }
        return 'illrequest.copyright.message';
    }

    public getSubTitleLabel() {
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            let serviceType = this.getServiceType();
            if (serviceType === 'AlmaResourceSharing') {
                return 'almaResourceSharing.copyright.sub_title';
            } else {
                return 'almaDigitization.copyright.sub_title';
            }
        }
        return 'illrequest.copyright.sub_title';
    }
    
    public isSuprima(){
        return this.configurationUtil.isSuprima();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/copyright/copyright.directive.ts